import { render } from "./SchemaRibbon.vue?vue&type=template&id=5b343fee&scoped=true"
import script from "./SchemaRibbon.vue?vue&type=script&lang=js"
export * from "./SchemaRibbon.vue?vue&type=script&lang=js"

import "./SchemaRibbon.vue?vue&type=style&index=0&id=5b343fee&lang=scss&scoped=true"

import exportComponent from "/app/tmp/bambl/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b343fee"]])

export default __exports__